<template>
  <c-ticket-container>
    <img :src="getImage(`bild-teaser-miwula-yullbe-${$i18n.locale}.jpg`)">

    <div class="yullbe-container">
      <h2>{{ getLabel('introduction.miwula_yullbe_select_head') }}</h2>
      <p v-html="getLabel('introduction.miwula_yullbe_select')" />
    </div>
    <div class="yullbe-container">
      <c-yullbe-rooms />
    </div>
    <div
      v-if="cls != null"
      class="yullbe-container"
    >
      <h2>{{ getLabel(`introduction.miwula_yullbe_select_${cls == 0 ? 'go' : 'pro'}_head`) }}</h2>
      <div v-html="getLabel(`introduction.miwula_yullbe_select_${cls == 0 ? 'go' : 'pro'}`)" />
    </div>
    <template v-if="cls != null">
      <div
        v-if="isLoading"
        class="yullbe-spinner"
      >
        <c-loader-spinner />
      </div>
      <div
        v-else-if="experiences.length > 0"
        class="yullbe-container-slots"
      >
        <!-- TODO grouping -->
        <c-tours-item
          v-for="item in experiences"
          :key="item.gap"
          :gap="item.gap"
          :time="item.von_zeit"
          :name="item[`name_${$i18n.locale}`]"
          :description="item[`spezifische_beschreibung_${$i18n.locale}`]"
          :free-spots="item.fuehrung_frei"
          :sold-spots="item.fuehrung_verkauft"
          :price-groups="item.preisgruppen"
          :price-deviation="item.preisabweichung"
          :basetype="item.experience_basetype"
          :typ="item.experience_type"
          :cls="item.experience_class"
        />
      </div>
      <div
        v-else
        class="yullbe-container"
        v-html="getLabel('introduction.miwula_yullbe_none_found')"
      />
    </template>
  </c-ticket-container>
</template>

<script>
import CLoaderSpinner from './loaderSpinner.vue'
import CTicketContainer from './CTicketContainer.vue'
import CToursItem from './CToursItem.vue'
import CYullbeRooms from './yullbeRooms.vue'

import eventBus from '../eventBus.js'

import labelMixin from '../mixins/label.js'

import { BASE_URL } from '../settings.js'

export default {
  name: 'CYullbeSelection',

  components: {
    CLoaderSpinner,
    CTicketContainer,
    CToursItem,
    CYullbeRooms
  },

  mixins: [labelMixin],

  data () {
    return {
      isLoading: true
    }
  },

  computed: {
    experiences () {
      return this.$store.state.tours
    },
    date () {
      return this.$store.state.ticketSelection.selectedDate
    },
    cart () {
      return this.$store.state.cart.tours
    },
    cls () {
      return this.$store.state.yullbeSelectedClass
    }
  },

  watch: {
    date () {
      this.getExperiences()
    },
    cart () {
      this.getExperiences()
    },
    cls () {
      this.getExperiences()
    }
  },

  methods: {
    async getExperiences () {
      this.isLoading = true

      try {
        await this.$store.dispatch('getTours', { date: this.date, basetype: 2, cls: this.cls })
      } catch (error) {
        eventBus.emit('handleError', error.response.data)
      } finally {
        this.isLoading = false
      }
    },

    getImage (name) {
      return `${BASE_URL}static/img/${name}`
    }
  }
}
</script>

<style>
  .yullbe-container {
    background-color: #fff;

    padding: 2rem;
  }

  .yullbe-container-slots {
    background-color: #fff;
  }

  .yullbe-spinner {
    background-color: #fff;
    text-align: center;
    padding: 2em;
  }
</style>
